import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'fi-detail-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false,
})
export class ContactDetailBreadcrumb {
  @Input() number: string;

  constructor(
    private router: Router,
  ) {
  }


  backToList(): void {
    this.router.navigate(['/'],);
  }
}
